// extracted by mini-css-extract-plugin
module.exports = {"numbers":"Numbers--numbers--2UhEs"};